import { FC } from 'react'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { ExportDefinition } from '../types'
import { DownloadIcon, ExportRowIcon } from './ExportIcons'
import { MonthPicker } from './MonthPicker'

interface ExportRowProps {
  exportDefinition: ExportDefinition
  selectedMonth?: string
  onMonthChange?: (yyyymm: string) => void
  onExport: () => void
  isLoading?: boolean
  isDisabled?: boolean
}

export const ExportRow: FC<ExportRowProps> = ({
  exportDefinition,
  selectedMonth,
  onMonthChange,
  onExport,
  isLoading,
  isDisabled,
}) => {
  return (
    <Flex
      align="center"
      gap="14px"
      px="18px"
      py="14px"
      borderBottom="1px solid"
      borderColor="gray.100"
      _last={{ borderBottom: 'none' }}
      _hover={{ bg: 'gray.50' }}
      transition="background 0.12s"
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
    >
      <ExportRowIcon variant={exportDefinition.iconVariant} />
      <Box flex="1" minW={0}>
        <Text fontSize="13px" fontWeight="semibold" color="gray.800" mb="2px">
          {exportDefinition.name}
        </Text>
        <Text fontSize="12px" color="gray.400" lineHeight="1.4">
          {exportDefinition.description}
        </Text>
      </Box>
      <Flex
        align="center"
        gap="10px"
        flexShrink={0}
        w={{ base: '100%', md: 'auto' }}
        justify={{
          base: exportDefinition.requiresMonth ? 'space-between' : 'flex-end',
          md: 'flex-end',
        }}
      >
        {exportDefinition.requiresMonth && selectedMonth && onMonthChange ? (
          <MonthPicker value={selectedMonth} onChange={onMonthChange} />
        ) : null}
        <Button
          size="sm"
          h="34px"
          px="14px"
          fontSize="12px"
          fontWeight="semibold"
          colorScheme="blue"
          bg="blue.600"
          _hover={{ bg: 'blue.700' }}
          onClick={onExport}
          isLoading={isLoading}
          isDisabled={isDisabled}
          whiteSpace="nowrap"
        >
          <Flex as="span" align="center" gap="6px">
            <DownloadIcon />
            Export CSV
          </Flex>
        </Button>
      </Flex>
    </Flex>
  )
}
